import { Link, NavLink } from "react-router-dom";
import { Box, Button, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { DATE_FORMAT_FRONT } from "../../../utils/constants";

const account_name = {
  headerName: "Account",
  wrapText: true,
  autoHeight: true,
  sortable: true,
  field: "account_name",
  minWidth: 300,
  maxWidth: 300,
  filter: true,
  comparator: () => {}, //disable default sorting
  cellRenderer: (params) => (
    <Typography fontSize={12}>{params.data.account_name}</Typography>
  ),
};

const account_internal_id = {
  headerName: "Internal ID",
  wrapText: true,
  autoHeight: true,
  sortable: true,
  field: "internal_id",
  maxWidth: 120,
  filter: true,
  comparator: () => {}, //disable default sorting
  cellRenderer: (params) => (
    <Typography fontSize={12}>{params.data.internal_id}</Typography>
  ),
};

const owedLifeTime = {
  headerName: "Lifetime B.",
  wrapText: true,
  autoHeight: true,
  sortable: true,
  field: "life_time_balance",
  maxWidth: 120,
  filter: true,
  comparator: () => {}, //disable default sorting
  cellRenderer: (params) => (
    <Typography fontSize={12}>{params.data.life_time_balance}</Typography>
  ),
};
const owedCurrent = {
  headerName: "Current",
  wrapText: true,
  autoHeight: true,
  sortable: true,
  field: "balance_0",
  maxWidth: 100,
  filter: true,
  comparator: () => {}, //disable default sorting
  cellRenderer: (params) => (
    <Typography fontSize={12}>{params.data.balance_0}</Typography>
  ),
};
const owedlt30 = {
  sortable: true,
  minWidth: 80,
  maxWidth: 80,
  headerName: "B. 30",
  field: "balance_30",
  valueGetter: (params) => params.data.balance_30 || 0,
  comparator: () => {}, //disable default sorting
  cellRenderer: (params) => (
    <Typography fontSize={12}>{params.data.balance_30}</Typography>
  ),
};

const owedlt60 = {
  sortable: true,
  minWidth: 80,
  maxWidth: 80,
  headerName: "B. 60",
  field: "balance_60",
  valueGetter: (params) => params.data.balance_60 || 0,
  comparator: () => {}, //disable default sorting
  cellRenderer: (params) => (
    <Typography fontSize={12}>{params.data.balance_60}</Typography>
  ),
};

const owedlt90 = {
  sortable: true,
  minWidth: 80,
  maxWidth: 80,
  headerName: "B. 90",
  field: "balance_90",
  valueGetter: (params) => params.data.balance_90 || 0,
  comparator: () => {}, //disable default sorting
  cellRenderer: (params) => (
    <Typography fontSize={12}>{params.data.balance_90}</Typography>
  ),
};

const owedlt120 = {
  sortable: true,
  minWidth: 100,
  maxWidth: 100,
  headerName: "B. 120",
  field: "balance_120",
  valueGetter: (params) => params.data.balance_120 || 0,
  comparator: () => {}, //disable default sorting
  cellRenderer: (params) => (
    <Typography fontSize={12}>{params.data.balance_120}</Typography>
  ),
};

const owedlt180 = {
  sortable: true,
  minWidth: 100,
  maxWidth: 100,
  headerName: "B. 150",
  field: "balance_150",
  valueGetter: (params) => params.data.balance_150 || 0,
  comparator: () => {}, //disable default sorting
  cellRenderer: (params) => (
    <Typography fontSize={12}>{params.data.balance_150}</Typography>
  ),
};

const managers = {
  sortable: true,
  minWidth: 150,
  maxWidth: 150,
  headerName: "Collectors",
  field: "collector",
  filter: true,
  valueGetter: (params) =>
    params.data?.managers?.map((manager) => manager.name).join(","),
  cellRenderer: (params) => {
    const managers = params.data?.managers
      ?.map((manager) => manager.name)
      .join(",");
    return (
      <Box>
        {managers && <Typography fontSize={12}>{managers}</Typography>}
        {!managers && (
          <Typography fontSize={12} color={"error"}>
            No manager!
          </Typography>
        )}
      </Box>
    );
  },
  wrapText: true,
  autoHeight: true,
  comparator: () => {}, //disable default sorting
};

const hasCollector = {
  sortable: true,
  minWidth: 120,
  maxWidth: 120,
  headerName: "Has Collectors",
  field: "hasCollector",
  filter: true,
  valueGetter: (params) =>
    params.data?.managers?.length > 0 ? "true" : "false",
  wrapText: true,
  autoHeight: true,
  hide: true,
};

const account_general_note = {
  sortable: true,
  minWidth: 180,
  headerName: "account_general_note",
  field: "account_general_note",
  filter: true,
  valueGetter: (params) => params.data?.account_general_note,
  wrapText: true,
  autoHeight: true,
  hide: true,
};

const task_date = {
  sortable: true,
  minWidth: 120,
  maxWidth: 120,
  headerName: "Date",
  field: "date",
  filter: true,
  valueGetter: (params) =>
    params.data.date ? dayjs(params.data.date).format("YYYY-MM-DD") : "-",
  cellRenderer: (params) => (
    <Typography fontSize={12}>
      {params.data.date
        ? dayjs(params.data.date).format(DATE_FORMAT_FRONT)
        : "-"}
    </Typography>
  ),
  wrapText: true,
  autoHeight: true,
  sort: "asc",
  comparator: () => {}, //disable default sorting
};

const CollectionsCols = [
  task_date,
  account_internal_id,
  account_name,
  managers,
  hasCollector,
  //last_call,
  owedLifeTime,
  owedCurrent,
  owedlt30,
  owedlt60,
  owedlt90,
  owedlt120,
  owedlt180,
];

export default CollectionsCols;
